import React from 'react';
export function RepeatIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.032V11L9 7l5-4v3h5a4 4 0 014 4v4a4 4 0 01-4 4h-2v-2h2a2 2 0 002-2v-4a2 2 0 00-2-2h-5v.032zM1 10a4 4 0 014-4h2v2H5a2 2 0 00-2 2v4a2 2 0 002 2h4v-3l5 4-5 4v-3H5a4 4 0 01-4-4v-4z"
  }));
}